const modules = JSON.parse(document.getElementById('StudioComponentModules')?.textContent || '{}');
const started = new Set();
let selector = Object.keys(modules).join(',');
const refreshSelector = () => {
  selector = Object.keys(modules).filter(name => !started.has(modules[name])).join(',');
};
function enhance(root) {
  if (!selector) return;
  const elements = [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  for (const element of elements) {
    const url = modules[element.localName];
    if (!url || started.has(url)) continue;
    started.add(url);
    import(url).catch(error => {
      started.delete(url);
      refreshSelector();
      console.error('Theme component could not load', error);
    });
  }
  refreshSelector();
}
enhance(document);
const roots = new Set();
let queued = false;
new MutationObserver(records => {
  if (!selector) return;
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (!(node instanceof Element)) continue;
      roots.add(node);
    }
  }
  if (!roots.size || queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    for (const root of roots) {
      if (!root.isConnected) continue;
      let ancestor = root.parentElement;
      while (ancestor && !roots.has(ancestor)) ancestor = ancestor.parentElement;
      if (!ancestor) enhance(root);
    }
    roots.clear();
  });
}).observe(document.body, { childList: true, subtree: true });
